import { MapPin } from "lucide-react";
import { useLanguage } from "../i18n";

export default function Marquee() {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-sand/10 bg-navy py-7">
      <div className="marquee-track flex w-max items-center gap-12 pr-12">
        {items.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-12">
            <span className={`whitespace-nowrap font-display text-2xl tracking-wide sm:text-3xl ${i % 2 ? "italic text-sand" : "text-white/85"}`}>
              {item}
            </span>
            <MapPin className="h-4 w-4 shrink-0 text-sky/70" />
          </span>
        ))}
      </div>
    </div>
  );
}
